import { ThemeName } from "@store/theme";

export default (theme: any, name: ThemeName) => {
    return theme.name === name;
};
